import { LOCALIZATION_SUCCESS } from '../actionTypes';

export const mutations = {
	[LOCALIZATION_SUCCESS]: (state, payload) => {
		state.Popispoli = payload.Popispoli;
		state.Popisostatni = payload.Popisostatni;
		state.Menu = payload.Menu;
		state.Formular = payload.Formular;
		state.ChyboveHlasky = payload.ChyboveHlasky;
	},
};
